export interface SceneCardCopy {
  action: 'Apply';
  status: 'Applied' | 'Saved room look';
}

/** Operator-facing scene language. Controller APIs retain their `recall_scene` name. */
export function sceneCardCopy(applied: boolean): SceneCardCopy {
  return {
    action: 'Apply',
    status: applied ? 'Applied' : 'Saved room look',
  };
}

export function sceneApplyTakeoverAction(name: string): string {
  return `applies "${name}"`;
}

export function sceneAppliedNotice(name: string): string {
  return `Applied ${name}`;
}
